import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { getClosestCardHeader } from '@lib/popups';
import { getTimelineSummarySelector } from './@arch/selectors';
import React from 'react';

import { DateRangePicker, DateRangePickerParams } from '@ui/DateRangePicker';
import { UpdateQueryParams, useCurrentCustomer, useSonarSelector } from '@hooks';

export interface TimelineDatePickerProps {
	endDate?: string;
	onChange: UpdateQueryParams<DateRangePickerParams>;
	startDate?: string;
}

export const TimelineDatePicker: React.FC<TimelineDatePickerProps> = ({ endDate, onChange, startDate }) => {
	const { id, timelineRetentionPeriod } = useCurrentCustomer();
	const isRequested = useSonarSelector(getTimelineSummarySelector.isRequested);

	return (
		<div className='timeline-date-picker'>
			{ COPY_SPECIFIC.CHANGES_FROM }
			<DateRangePicker
				disabled={ isRequested }
				endDate={ endDate }
				getPopupContainer={ getClosestCardHeader }
				historyLimit={ timelineRetentionPeriod }
				loading={ !id }
				onChange={ onChange }
				startDate={ startDate } />
		</div>
	);
};
